import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CopyButton } from '@interxfi/design-system/components/copy-button/copy-button';
import { AssetBreadcrumb } from '../../../../../../features/asset/asset-breadcrumb';
import { getAssetDetailPath } from '../../../../../../features/asset/asset-routing';
import { AssetLogoBreadcrumb } from '../../../../../../features/asset/logo/asset-logo-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/asset/_asset/$assetId/_detail')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `asset-${params.assetId}`,
        label: <AssetBreadcrumb assetId={params.assetId} />,
        prefix: <AssetLogoBreadcrumb assetId={params.assetId} />,
        to: getAssetDetailPath(params.assetId),
        suffix: <CopyButton content={params.assetId} label="Copy Asset ID" tooltip={{ copy: params.assetId, copied: 'Copied Asset ID' }} />,
      }),
    }) satisfies AggregateBreadcrumb,
});
